import * as actions from './../catalogActions';

export default function getData(matchedRoute) {
  return dispatch => {
    return new Promise(resolve => {
      const fakeDispatch = objToDispatch => {
        dispatch(objToDispatch);
        resolve();
      };

      // Load limited time offers
      actions.getLimitedTimeOffers()(dispatch);
      
      return actions.getProductByEAN(matchedRoute.params.ean)(fakeDispatch);
    });
  };
}
